import _ from 'lodash';

export default function calculateSuggestedMin(datasets, budgetValue) {
  const allY = _.flatMap(datasets || [], (dataset) => dataset?.data || [])
    .map((point) => point?.y)
    .filter(_.isNumber);

  let suggestedMin = 0;
  if (allY.length) suggestedMin = Math.min(0, ...allY);
  if (_.isNumber(budgetValue)) suggestedMin = Math.min(suggestedMin, budgetValue);

  return suggestedMin;
}
